



































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'remainingSumTable'
})
export default class RemainingSumTable extends Vue {
  @Prop({ default: () => {} }) public tableDetail: any
  @Prop({ default: '' }) public classNameSelf: string
}
